import { GatsbyBrowser } from "gatsby";

/**
 * Deep-link catégorie : le shell SSR est déjà aligné à scrollY=0.
 * Empêcher gatsby-react-router-scroll de restaurer un Y sessionStorage périmé
 * (ex. @@scroll|/…/maki/|initial = 140) au componentDidMount.
 */
const isCategoryDeepLinkPath = (): boolean => {
  if (typeof document === "undefined") return false;
  return !!document.querySelector(
    ".category-details--deep-link-fill, [data-ssr-listing='true'] .category-details"
  );
};

const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps: { location },
  prevRouterProps,
}) => {
  const { location: prevLocation } = prevRouterProps || {};
  const st = location.state as Record<string, unknown> | undefined;
  const isModal = st?.modal;
  const keepScroll = !!st?.keepScroll;
  const preventUpdateScroll = st?.noScroll;
  const isScrollNavigation = !!st?.scrollNavigation || !!st?.isScrolling;
  const locationChanged = location.pathname !== prevLocation?.pathname;

  // Hard load / hydrate deep-link : ne pas appliquer la position sauvée.
  if (!prevLocation && isCategoryDeepLinkPath()) {
    return false;
  }

  // Sync URL listing (menu / scroll spy) : jamais restaurer / jumper le scroll.
  if (preventUpdateScroll || keepScroll || isScrollNavigation || isModal) {
    return false;
  }

  // Same pathname = overlay modal open/close (isModalOpen) — keep scroll.
  // Do not honor legacy modalShouldUpdateScroll on same-path navigations.
  return locationChanged;
};

export default shouldUpdateScroll;
